var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoFiltro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.674,
    height: 13.062,
    viewBox: "0 0 15.674 13.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66306",
    "data-name": "Trazado 66306",
    d: "M15.674,43.32a.655.655,0,0,1-.653.653H.653a.653.653,0,0,1,0-1.306H15.021A.655.655,0,0,1,15.674,43.32ZM9.8,54.423H5.878a.653.653,0,0,0,0,1.306H9.8a.653.653,0,0,0,0-1.306Zm2.612-5.878H3.266a.653.653,0,1,0,0,1.306h9.143a.653.653,0,1,0,0-1.306Z",
    transform: "translate(0 -42.667)",
    fill: "#003763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFiltro);
export default __webpack_public_path__ + "static/media/Icono-Filtro.eeeecdc37b914b75593270609bcb7941.svg";
export { ForwardRef as ReactComponent };